<div class="content-page">
  <div class="content-page__header">
    @if (breakpointService.isMobile()) {
      <div class="content-page__label">Testimonials</div>
    }
    <app-header-banner
      bannerText=""
      [localAsset]="true"
      [showContent]="!breakpointService.isMobile()"
      [bannerImage]="breakpointService.isMobile() ? 'about_banner_mobile.jpg' : 'trip_testimonials.jpg'"
    ></app-header-banner>
  </div>

  <div class="company-container__box">

    <div class="company-container__content">
      <h1
        class="content-page__title content-page__title--testimonials">{{ (breakpointService.isMobile() ? 'TRIP_TESTIMONIALS.WHAT_PEOPLE_SAY' : 'TRIP_TESTIMONIALS.TITLE') | translate }}</h1>

      @if(breakpointService.isMobile()) {
          <div class="content-page__testimonials">
              @for (testimonial of pagedTestimonials; track testimonial) {
                  <div class="content-page__testimonial">
                      <app-testimonial-card
                              [cdnUrl]="cdnUrl"
                              [testimonial]="testimonial"
                              [showMapImage]="true"
                              [disableTruncate]="true"
                      ></app-testimonial-card>
                  </div>
              }

              @if (pagedTestimonials.length && pagedTestimonials.length < allCustomerTestimonials.length) {
                  <div class="content-page__more-container">
                      <a class="content-page__more" (click)="loadMore($event)">
                          {{ 'ACTIONS.SEE_MORE' | translate }}
                      </a>
                  </div>
              }
          </div>
      } @else {
          <div class="content-page__testimonials">
              @for (testimonial of pagedTestimonials; track testimonial) {
                  <div class="testimonial-item">
                      <div class="testimonial-item__title">
                          <div class="user-avatar">
                              <img [src]="testimonial.picture" [alt]="testimonial?.user">
                          </div>
                          <div class="user-text">
                              <h5>{{ testimonial.title }}</h5>
                              <p>{{ testimonial?.user }}</p>
                              <p class="description">{{ testimonial.description }}</p>
                          </div>
                      </div>
                      <div class="testimonial-item__image-box">
                          <img [src]="testimonial.map" alt="short map info">
                      </div>
                  </div>
              }

              @if (pagedTestimonials.length && pagedTestimonials.length < allCustomerTestimonials.length) {
                  <div class="content-page__more">
                      <a href="" (click)="loadMore($event)">{{ 'ACTIONS.SHOW_MORE' | translate }}</a>
                  </div>
              }
          </div>
      }
    </div>
  </div>
</div>

@if (breakpointService.isMobile()) {
  <app-start-planing-mobile></app-start-planing-mobile>
}
